export default __webpack_public_path__ + "static/media/Desafios.c2373352.png";